import { useState, useEffect } from 'react';
import api from '../utils/api';

export default function Templates() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', subject: '', body: '' });
  const [saving, setSaving] = useState(false);

  const fetchTemplates = async () => {
    try {
      const { data } = await api.get('/templates');
      setTemplates(data.templates);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchTemplates(); }, []);

  const openAdd = () => {
    setEditing(null);
    setForm({ name: '', subject: '', body: '' });
    setShowAdd(true);
  };

  const openEdit = (t) => {
    setEditing(t.id);
    setForm({ name: t.name, subject: t.subject || '', body: t.body });
    setShowAdd(true);
  };

  const save = async () => {
    if (!form.name || !form.body) return alert('Name and body required');
    setSaving(true);
    try {
      if (editing) {
        await api.put(`/templates/${editing}`, form);
      } else {
        await api.post('/templates', form);
      }
      setShowAdd(false);
      setEditing(null);
      setForm({ name: '', subject: '', body: '' });
      fetchTemplates();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to save');
    } finally {
      setSaving(false);
    }
  };

  const deleteTemplate = async (id) => {
    if (!window.confirm('Delete this template?')) return;
    await api.delete(`/templates/${id}`);
    fetchTemplates();
  };

  const inputStyle = { width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: '12px', color: '#666', marginBottom: '4px' };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
        <h2 style={{ fontSize: '18px', fontWeight: '600' }}>Reply templates</h2>
        <button onClick={openAdd}
          style={{ padding: '8px 16px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '500', cursor: 'pointer' }}>
          + New template
        </button>
      </div>

      {showAdd && (
        <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '10px', padding: '16px', marginBottom: '16px' }}>
          <h3 style={{ fontSize: '14px', fontWeight: '600', marginBottom: '14px' }}>{editing ? 'Edit template' : 'New template'}</h3>
          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>Template name</label>
            <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
              placeholder="e.g. Welcome to tapGP"
              style={inputStyle} />
          </div>
          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>Subject line <span style={{ color: '#bbb' }}>(optional — auto-fills subject when template is inserted)</span></label>
            <input value={form.subject} onChange={e => setForm(p => ({ ...p, subject: e.target.value }))}
              placeholder="e.g. Your tapGP appointment"
              style={inputStyle} />
          </div>
          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>
              Template body — use <code>{'{{patient_name}}'}</code> for patient's first name
            </label>
            <textarea value={form.body} onChange={e => setForm(p => ({ ...p, body: e.target.value }))}
              placeholder="Hi {{patient_name}},&#10;&#10;Your message here..."
              rows={8}
              style={{ ...inputStyle, fontFamily: 'inherit', resize: 'vertical' }} />
          </div>
          <div style={{ display: 'flex', gap: '8px' }}>
            <button onClick={save} disabled={saving}
              style={{ padding: '8px 16px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', cursor: 'pointer', opacity: saving ? 0.7 : 1 }}>
              {saving ? 'Saving...' : editing ? 'Save changes' : 'Create template'}
            </button>
            <button onClick={() => { setShowAdd(false); setEditing(null); }}
              style={{ padding: '8px 16px', background: '#fff', border: '1px solid #ddd', borderRadius: '8px', fontSize: '13px', cursor: 'pointer' }}>
              Cancel
            </button>
          </div>
        </div>
      )}

      <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: '10px', overflow: 'hidden' }}>
        {loading ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#999' }}>Loading...</div>
        ) : templates.length === 0 ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#999' }}>No templates yet — create your first one!</div>
        ) : templates.map((t, i) => (
          <div key={t.id} style={{ padding: '14px 16px', borderBottom: i < templates.length - 1 ? '1px solid #f0f0f0' : 'none', display: 'flex', alignItems: 'start', gap: '12px' }}>
            <div style={{ flex: 1 }}>
              <p style={{ fontSize: '14px', fontWeight: '500', marginBottom: '4px' }}>{t.name}</p>
              {t.subject && <p style={{ fontSize: '12px', color: '#185FA5', marginBottom: '4px' }}>Subject: {t.subject}</p>}
              <p style={{ fontSize: '12px', color: '#888', whiteSpace: 'pre-line', maxHeight: '60px', overflow: 'hidden' }}>{t.body}</p>
            </div>
            <div style={{ display: 'flex', gap: '6px', flexShrink: 0 }}>
              <button onClick={() => openEdit(t)}
                style={{ padding: '5px 12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', background: '#fff' }}>
                Edit
              </button>
              <button onClick={() => deleteTemplate(t.id)}
                style={{ padding: '5px 12px', border: '1px solid #ffcccc', borderRadius: '6px', fontSize: '12px', cursor: 'pointer', background: '#fff', color: '#c00' }}>
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
